import cn from 'classnames'
import { SearchRefinements } from './SearchRefinements'

type SidebarRefinementsProps = React.ComponentProps<'nav'>

export function SidebarRefinements(props: SidebarRefinementsProps) {
  return (
    <nav {...props} className={cn('flex flex-col', props.className)}>
      <SearchRefinements showClearButton />
    </nav>
  )
}
